<ngx-smart-modal #DeleteKitModal [identifier]="modalType" [title]="modalTitle"
    [disableConfirmButton]="disableConfirmButton" [confirmButtonText]="confirmButtonText">
    <div>
        <p [innerHTML]="warningMessage"></p>
    </div>
</ngx-smart-modal>